import { Snackbar } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { notificationDuration } from "../../config";
import { setNotification } from "../../redux";
import { getNotification } from "../../redux/selectors";

export function Notifier() {
  const notification = useSelector(getNotification);
  const dispatch = useDispatch();
  const handleClose = (event, reason) => {
    if (reason === "clickaway" && notification?.duration <= 0) {
      return;
    }
    dispatch(setNotification(null));
  };
  if (notification) {
    const autoHideDuration =
      notification?.duration <= 0
        ? null
        : notification?.duration ?? notificationDuration;
    return (
      <Snackbar
        open={notification}
        message={notification?.message} //ignored when notification.children is set
        action={notification?.action} //ignored when notification.children is set
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
        ClickAwayListenerProps={{
          mouseEvent: false,
          touchEvent: false,
          onClickAway: () => null,
        }}
      >
        {notification?.children}
      </Snackbar>
    );
  }
  return null;
}
